import React from 'react';
import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import getRouterConfig from './common/router';

interface RouterConfigProps {}

const RouterConfig: React.FC<RouterConfigProps> = () => {
    const routerConfig = getRouterConfig();
    const BasicLayout = routerConfig["/apps"].component;
    const Login = routerConfig["/login"].component;
    const RegisterUser = routerConfig["/registerUser"].component;


    return (
        <Router>
            <Switch>
                <Redirect exact from='/' to='/login'/>
                <Route path='/apps' component={BasicLayout}/>
                <Route path='/login' component={Login}/>
                <Route path='/registerUser' component={RegisterUser}/>
            </Switch>
        </Router>
    )
}

export default RouterConfig;